export default __webpack_public_path__ + "static/media/pipelines-purify.c0528db3.svg";